(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-video-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-atelier-stories]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const track = section.querySelector('[data-stories-track]');
      const previous = section.querySelector('[data-stories-prev]');
      const next = section.querySelector('[data-stories-next]');
      if (!track) return;

      const step = () => {
        const card = track.querySelector('.atelier-story');
        if (!card) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
        section.classList.toggle('atelier-stories--static', maxScroll <= 2);
      };

      previous?.addEventListener('click', () => {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
function setupAtelierFooter(){const mobile=window.matchMedia('(max-width: 740px)');const groups=document.querySelectorAll('.ah-footer-group');const sync=()=>groups.forEach(group=>{group.open=!mobile.matches;});sync();mobile.addEventListener('change',sync);groups.forEach(group=>group.querySelector('summary').addEventListener('click',event=>{if(!mobile.matches)event.preventDefault();}));}
setupAtelierFooter();
document.addEventListener('shopify:section:load',setupAtelierFooter);

document.querySelectorAll('.ah-ugc').forEach(section=>{
const track=section.querySelector('.ah-ugc-track');
section.querySelectorAll('[data-ugc-dir]').forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('.ah-ugc-card');const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);const max=track.scrollWidth-track.clientWidth;let next=track.scrollLeft+Number(button.dataset.ugcDir)*step;if(next>max+1)next=0;if(next<0)next=max;track.scrollTo({left:next,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));
section.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>section.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();})));
});

function setupAtelierCollectorTabs(){
 const videos=document.querySelector('.ah-ugc');
 const gallery=document.querySelector('main gallery-list') || document.querySelector('gallery-list');
 if(!videos || !gallery || document.querySelector('.ah-collector-tabs'))return;
 const host=gallery.parentElement;
 host.classList.add('ah-collector-world');
 const heading=host.querySelector('.section__header');
 if(heading){
 heading.classList.add('ah-collector-world-heading');
 const title=heading.querySelector('h3');
 if(title)title.textContent='The Collector’s World';
 const subtitle=heading.querySelector('h2');
 if(subtitle)subtitle.hidden=true;
 }
 const tabs=document.createElement('div');
 tabs.className='ah-collector-tabs';tabs.setAttribute('role','tablist');tabs.setAttribute('aria-label','Explore Atelier Home');
 const panels=[gallery,videos];
 const names=['Collector Gallery','Unboxings'];
 panels.forEach((panel,i)=>{
  panel.id='ah-collector-panel-'+i;panel.classList.add('ah-collector-panel');
  panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby','ah-collector-tab-'+i);
  const tab=document.createElement('button');tab.type='button';tab.id='ah-collector-tab-'+i;
  tab.textContent=names[i];tab.setAttribute('role','tab');tab.setAttribute('aria-controls',panel.id);
  tabs.appendChild(tab);
 });
 host.insertBefore(tabs,gallery);host.appendChild(videos);
 const community=document.querySelector('.ah-instagram-community');
 if(community)host.appendChild(community);

 const buttons=[...tabs.children];
 function select(index,focus){
  buttons.forEach((button,i)=>{button.setAttribute('aria-selected',String(i===index));button.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
  if(index===0)videos.querySelectorAll('video').forEach(video=>video.pause());
  if(focus)buttons[index].focus();
  window.dispatchEvent(new Event('resize'));
 }
 buttons.forEach((button,i)=>{
  button.addEventListener('click',()=>select(i,false));
  button.addEventListener('keydown',event=>{
   let next;if(event.key==='ArrowRight'||event.key==='ArrowLeft')next=1-i;
   if(event.key==='Home')next=0;if(event.key==='End')next=1;
   if(next!==undefined){event.preventDefault();select(next,true);}
  });
 });
 select(0,false);
}
setupAtelierCollectorTabs();
document.addEventListener('shopify:section:load',setupAtelierCollectorTabs);


  } catch(e) { console.error(e); }
})();
})();
